import { paths } from './paths.js'

type TrackTraceLinkParams = { barcode: string; postalCode?: string }

export const trackTraceLinks = {
  trackTraceLink: ({ barcode, postalCode }: TrackTraceLinkParams): string =>
    postalCode ? `/${barcode}/${postalCode}` : `/${barcode}`,

  trackTraceDeliveryCodeLink: (params: TrackTraceLinkParams): string =>
    `${trackTraceLinks.trackTraceLink(params)}/${paths.DELIVERY_CODE}`,

  trackTraceAgreedPlaceProofOfDeliveryLink: (params: TrackTraceLinkParams): string =>
    `${trackTraceLinks.trackTraceLink(params)}/${paths.AGREED_PLACE_PROOF_OF_DELIVERY}`,

  trackTraceDetailsLink: (params: TrackTraceLinkParams): string =>
    `${trackTraceLinks.trackTraceLink(params)}/${paths.DETAILS}`,

  trackTraceLockerCodesLink: (params: TrackTraceLinkParams): string =>
    `${trackTraceLinks.trackTraceLink(params)}/${paths.LOCKER_CODES}`,

  trackTraceServicePointPickupCodeLink: (params: TrackTraceLinkParams): string =>
    `${trackTraceLinks.trackTraceLink(params)}/${paths.SP_PICKUP_CODE}`,

  trackTraceInterventionsLink: (params: TrackTraceLinkParams & { type?: string }) =>
    `${trackTraceLinks.trackTraceLink(params)}/${paths.INTERVENTIONS}${params.type ? `/${params.type}` : ''}`,

  trackTraceInterventionConfirmationLink: (params: TrackTraceLinkParams) =>
    `${trackTraceLinks.trackTraceLink(params)}/${paths.INTERVENTIONS}/${paths.CONFIRMATION}`,

  trackTraceSignatureLink: (params: TrackTraceLinkParams) =>
    `${trackTraceLinks.trackTraceLink(params)}/${paths.SIGNATURE}`,

  trackTraceQRcodeLink: (params: TrackTraceLinkParams) => `${trackTraceLinks.trackTraceLink(params)}/${paths.QRCODE}`,

  trackTraceReturnShipmentLink: (params: TrackTraceLinkParams) =>
    `${trackTraceLinks.trackTraceLink(params)}/${paths.RETURN_SHIPMENT}`,

  trackTraceReturnShipmentFindYourServicePointLink: (params: TrackTraceLinkParams) =>
    `${trackTraceLinks.trackTraceLink(params)}/${paths.RETURN_SHIPMENT}/${paths.FIND_YOUR_SERVICEPOINT}`,

  trackTraceLinks: () => ``,
}

export type TrackTraceLinks = typeof trackTraceLinks
